<template>
  <Route class="CardProjectDemo" :to="coverLink">
    <div class="details wrap">
      <Row class="bottom nowrap">
        <Column
          v-for="(detail, index) in details"
          :key="index"
          class="detail"
          :xl="3"
          :xs="12">
          <div class="content">
            <div class="label">
              {{ detail.label }}
            </div>
            <Row v-if="detail.valueBefore" class="value nowrap">
              <!-- eslint-disable-next-line vue/attributes-order -->
              <Column :md="6" :lg="12" :xxl="6">
                <div>
                  {{ detail.value }}
                </div>
              </Column>
              <!-- eslint-disable-next-line vue/attributes-order -->
              <Column :md="6" :lg="12" :xxl="6">
                <span class="cross-out">
                  {{ detail.valueBefore }}
                </span>
              </Column>
            </Row>
            <div v-else>
              <div class="value">
                {{ detail.value }}
              </div>
            </div>
          </div>
        </Column>
      </Row>
    </div>
    <Route class="coverLinkWrap" :to="coverLink">
      <div class="preview" :class="{ grayed: messageOverlay }">
        <div v-if="project.priceBefore" class="discountBlob">
          <div class="discountTextContainer">
            <div class="discountText">
              <span class="prefix">DABAR TIK</span>
              <br>
              <span class="suffix">{{ project.price }} Eur/kW</span>
            </div>
          </div>
        </div>
        <div class="sliderContainer">
          <CapacitySlider
            :sliderInterval="0.1"
            :total="project.capacity"
            :used="project.capacityUsed || 0" />
        </div>
        <Pic
          :src="project.imageUrl || 'https://sig-web-uploads.s3.eu-central-1.amazonaws.com/vievis_rsz_7e90f15d5c.jpeg'" />
        <div v-if="doShowStartDateStatus && !isStarted" class="startDateOverlay">
          Priimamos rezervacijos
        </div>
        <div v-if="messageOverlay" class="inactiveOverlay" />
        <div v-if="messageOverlay" class="messageOverlay">
          <span>{{ messageOverlay }}</span>
        </div>
        <div v-if="displayNameOverlay" class="nameOverlay">
          <span>{{ project.name }}</span>
        </div>
      </div>
    </Route>
  </Route>
</template>

<script>
import CapacitySlider from './CapacitySlider'
import { getters } from 'views/utils'

export default {
  components: { CapacitySlider },
  props: {
    project: Object,
    doShowStartDateStatus: {
      type: Boolean,
      default: false,
    },
    displayNameOverlay: {
      type: Boolean,
      default: false,
    },
    coverLinkProp: {
      type: Object,
    },
  },
  computed: {
    coverLink() {
      return this.coverLinkProp ||
        {
          name: 'ProjectDetails',
          params: { slug: this.project.slug },
        }
    },
    title() {
      return this.project.name.startsWith('Saulės Parkas')
        ? this.project.name
        : `Saulės Parkas „${this.project.name}“`
    },
    isReservationsActive() {
      return this.project.status === 'ACTIVE'
    },
    messageOverlay() {
      const messagesByStatus = {
        PLANNING: 'REZERVACIJA NETRUKUS',
        ACTIVE: null,
        FUNDED: null,
        CONSTRUCTION: 'REZERVACIJA BAIGTA',
        BUILT: 'IŠPARDUOTA',
      }

      return messagesByStatus[this.project.status]
    },
    isStarted() {
      const startDate = new Date(this.project.constructionDate)

      return startDate <= new Date()
    },
    startDate() {
      // const dateString = isStarted
      //   ? this.project.startedDate
      //   : this.project.startingDate

      const startDate = new Date(this.project.constructionDate)
      const month = `0${startDate.getMonth() + 1}`.slice(-2)

      return {
        label: this.isStarted
          ? 'Parkas pradėjo veikti'
          : 'Planuojama parko paleidimo data',
        value: `${startDate.getFullYear()} ${month}`,
      }
    },
    details() {
      return [
        {
          label: 'Galia:',
          value: `${this.project.capacity} kW`,
        },
        this.startDate,
        ...this.isReservationsActive
          ? [
            {
              label: 'Pirkimo kaina:',
              value: `${this.project.price} Eur/kW`,
              valueBefore: this.project.priceBefore ? `${this.project.priceBefore} Eur/kW` : null,
            },
            {
              label: 'Metinė priežiūros kaina:',
              value: `${this.project.maintenanceAnnual} Eur/kW`,
              valueBefore: this.project.maintenanceAnnualBefore ? `${this.project.maintenanceAnnualBefore} Eur/kW` : null,
            },
          ] : [],
      ]
    },
    reserveRoute() {
      return this.isAuth
        ? 'SelfReservationAdd'
        : 'SelfReservationAddGuest'
    },
    reservationsActive() {
      return this.reservations
        .filter(reservation => reservation.isReserved)
    },
    ...getters(),
  },
}
</script>

<style lang="scss">
.CardProjectDemo {
  background: $white;
  border-radius: $radius 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;

  .cross-out {
    position: relative;
    text-decoration: none;

    &::before {
      background: $red;
      border-radius: 0.1rem;
      content: '';
      display: block;
      height: 0.2rem;
      left: -5%;
      opacity: 0.8;
      position: absolute;
      top: 50%;
      transform: rotate(-5deg);
      white-space: nowrap;
      width: 100%;
    }
  }

  .coverLinkWrap {
    border-bottom: unset;
  }

  .discountBlob {
    align-content: center;
    background: $black;
    background-image: linear-gradient(120deg, $info 0%, $info-dark 100%);
    border-radius: $radius-round 0 0 $radius-round;
    display: flex;
    padding: 0 2rem 0 3rem;
    position: absolute;
    right: 0;
    text-align: right;
    top: 15%;
    z-index: 1;

    .discountTextContainer {
      padding: 1rem 0;

      .discountText {
        color: $white;
        font-weight: $bold;

        .prefix {
          font-size: $h4;
          @include lg {
            font-size: 2rem;
          }
        }

        .suffix {
          font-size: $h25;
          @include lg {
            font-size: $h2;
          }
        }
      }
    }
  }

  .wrap {
    padding: 2rem 3rem 0;
  }

  .details {
    .bottom {
      margin-bottom: 1rem;
      width: 100%;

      .detail {
        align-items: center;
        // border-top: solid 2px $black;
        display: flex;
        padding: 1rem 0;
        white-space: normal;
        @include md {
          padding: 1rem 0 1rem 1rem;
        }
        @include xl {
          border-left: solid 2px $black;

          &:nth-of-type(odd) {
            border-left: solid 2px $black;
            padding-left: 1rem;
          }

          &:first-of-type {
            border-left: none;
            padding-left: 0;
          }
        }

        > .content {
          display: flex;
          flex-direction: column;
          height: 100%;
          justify-content: space-between;
          width: 100%;
        }

        .label {
          font-size: 14px;
          margin-bottom: 0.5rem;
          opacity: 0.5;
        }

        .value {
          font-size: 1.125rem;
          font-weight: $bold;
        }
      }
    }
  }

  .preview {
    border-radius: $radius 0;
    height: 15rem;
    // opacity: 0.66;
    overflow: hidden;
    position: relative;

    &::before {
      background: linear-gradient(to top, rgba($black, 0.7), rgba($black, 0.1), transparent, transparent, transparent);
      bottom: 0;
      content: " ";
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
      transition: background-color 0.2s linear;
      z-index: 1;
    }

    .startDateOverlay {
      align-items: center;
      backdrop-filter: blur(8px);
      background:
        linear-gradient(
          to right,
          rgba($black, 0.38),
          rgba($black, 0.12)
        );
      border: 1px solid $white;
      border-radius: 999px;
      color: rgba($white, 0.96);
      display: flex;
      font-size: 1.05rem;
      font-weight: $semibold;
      left: 2rem;
      letter-spacing: -0.02rem;
      max-width: 80%;
      padding: 0.35rem 0.8rem;
      position: absolute;
      text-shadow: 0 1px 6px rgba($black, 0.45);
      top: 1rem;
      width: fit-content;
      z-index: 2;
    }

    .inactiveOverlay {
      background: $black;
      height: 100%;
      left: 0;
      opacity: 0.5;
      position: absolute;
      top: 0;
      width: 100%;
      z-index: 1;
    }

    .messageOverlay {
      align-items: center;
      display: flex;
      height: 100%;
      justify-content: center;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
      z-index: 2;

      > span {
        color: $white;
        font-size: $h3;
        font-weight: $bold;
        @include md {
          font-size: $h2;
        }
        // @include xl {
        //   font-size: $h1;
        // }
      }
    }

    .nameOverlay {
      margin: 2rem 5rem;
      position: absolute;
      top: 0;
      z-index: 2;

      > span {
        color: $white;
        font-size: $h4;
        font-weight: $bold;
        @include md {
          font-size: $h2;
        }
      }
    }

    .sliderContainer {
      bottom: 1rem;
      padding: 0 2rem 0 1rem;
      position: absolute;
      width: 100%;
      z-index: 1;
      @include lg {
        padding: 0 5rem;
      }
    }

    img {
      filter: brightness(0.8);
      height: 100%;
      object-fit: cover;
      transition: filter 0.2s linear;
      width: 100%;
    }

    &.grayed {
      img {
        filter: grayscale(80%);
      }
    }

    &:hover {
      &::before {
        background: linear-gradient(to top, rgba($black, 0.9), rgba($black, 0.2), transparent, transparent, transparent);
        bottom: 0;
        content: " ";
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        transition: background-color 0.2s linear;
        z-index: 1;
      }

      img {
        filter: brightness(1);
        transition: filter 0.2s linear;
      }
    }
  }

}
</style>
